import React from 'react';

export default class Links extends React.Component {
  render() {
    const { links, colorScale } = this.props;
    const duration = 1; //s
    const delay = .25 //s
    return (
      <g>
        <defs>
          <linearGradient id="fade-out">
            <stop
              offset="0"
              stopColor={colorScale('before')}
              stopOpacity={0.25} />
            <stop
              offset="0.685"
              stopColor={colorScale('before')}
              stopOpacity={0}>
              <animate attributeName="offset" values="0;.685" dur={.685*duration+"s"} begin={delay+"s"} />
            </stop>
          </linearGradient>

          <linearGradient id="fade-in">
            <stop
              offset="0.315"
              stopColor={colorScale('after')}
              stopOpacity={0}>
              <animate attributeName="stopOpacity" values="0;.25" dur={.315*duration+"s"} begin={delay+"s"} />
            </stop>
            <stop
              offset="1"
              stopColor={colorScale('after')}
              stopOpacity={0.25}>
              <animate attributeName="offset" values="0;1" dur={duration+"s"} begin={delay+"s"} />
            </stop>
            <stop
              offset="1"
              stopColor={colorScale('after')}
              stopOpacity={0}>
              <animate attributeName="offset" values="0;1" dur={duration+"s"} begin={delay+"s"} />
            </stop>
          </linearGradient>

          <linearGradient id="fade">
            <stop
              offset="0"
              stopColor={colorScale('before')}
              stopOpacity={0.5}/>
            <stop
              offset="1"
              stopColor={colorScale('after')}
              stopOpacity={0.5}>
              <animate attributeName="offset" values="0;1" dur={duration+"s"} begin={delay+"s"} />
            </stop>
            <stop
              offset="1"
              stopColor={colorScale('after')}
              stopOpacity={0}>
              <animate attributeName="offset" values="0;1" dur={duration+"s"} begin={delay+"s"} />
            </stop>

          </linearGradient>
        </defs>

        <g>
          {links.map(({ key, before, after }, i) => (
            <path
              key={key+"_"+i}
              fill={`url(#fade${!before.value ? '-in' : !after.value ? '-out' : ''})`}
              // d={`
              //     M ${before.x1} ${before.y0}
              //     C ${(before.x1 + after.x0) / 2} ${before.y0}
              //       ${(before.x1 + after.x0) / 2} ${after.y0}
              //       ${after.x0} ${after.y0}
              //     L ${after.x0} ${after.y1}
              //     C ${(before.x1 + after.x0) / 2} ${after.y1}
              //       ${(before.x1 + after.x0) / 2} ${before.y1}
              //       ${before.x1} ${before.y1}
              //     Z
              //   `}
              d={`
                  M ${before.x1 + 1} ${before.y0 + 0.5}
                  C ${(before.x1 + after.x0) / 2} ${before.y0 + 0.5}
                    ${(before.x1 + after.x0) / 2} ${after.y0 + 0.5}
                    ${after.x0 - 1} ${after.y0 + 0.5}
                  L ${after.x0 - 1} ${after.y1 - 0.5}
                  C ${(before.x1 + after.x0) / 2} ${after.y1 - 0.5}
                    ${(before.x1 + after.x0) / 2} ${before.y1 - 0.5}
                    ${before.x1 + 1} ${before.y1 - 0.5}
                  Z
                `}
            />
          ))}
        </g>
      </g>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Flows/Links.js